import axios from 'axios'
const hosts = {
  'm.ahyc-house.com': 'https://www.ahyc-house.com',
  'myitou.hzan.com.cn': 'https://yitou.hzan.com.cn',
  'myitou.shegongok.com': 'https://yitou.hzan.com.cn'
}
const local = /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname)
const client = axios.create({
  baseURL:
    window.AHYC_HOUSE_API_BASE ||
    hosts[window.location.hostname] ||
    (local ? '' : 'https://yitou.test'),
  timeout: 35000,
  withCredentials: false
})
function request(method, url, params, success, failure) {
  let token = ''
  try {
    token = localStorage.getItem('token') || ''
  } catch (e) {}
  return client({
    method,
    url,
    timeout: url === '/api/ai/follow-up' ? 65000 : 35000,
    headers: token ? { Authorization: 'Bearer ' + token } : {},
    data: /^(post|put)$/.test(method) ? params : undefined,
    params: /^(get|delete)$/.test(method) ? params : undefined
  })
    .then(response => {
      if (success) success(response.data)
      return response.data
    })
    .catch(error => {
      const response = error.response
      const message =
        response && response.data && response.data.message
          ? response.data.message
          : error.code === 'ECONNABORTED'
            ? '请求超时，请重试，填写内容已保留'
            : '网络连接失败，请检查网络后重试'
      if (response && response.status === 401 && url !== '/api/authorizations') {
        try {
          localStorage.removeItem('token')
        } catch (e) {}
        window.dispatchEvent(new Event('auth-expired'))
      }
      if (failure) {
        failure(response || { status: 0, data: { message } })
        return null
      }
      const normalized = new Error(message)
      normalized.status = response ? response.status : 0
      throw normalized
    })
}
export default {
  get: (url, params, success, failure) => request('get', url, params, success, failure),
  post: (url, params, success, failure) => request('post', url, params, success, failure),
  put: (url, params, success, failure) => request('put', url, params, success, failure),
  delete: (url, params, success, failure) => request('delete', url, params, success, failure)
}



// WEBPACK FOOTER //
// ./src/api/index.js